<template>
  <div class="save">
    <save-page-header title="Country"></save-page-header>
    <el-form class="mt-30" :label-width="labelWidth + 'px'">
      <translatable-input
        :errors="errors"
        :source.sync="form.names"
        sourceKey="names"
        :isDisabled="true"
        title="Name"
        :label-width="labelWidth"
      />
      <el-form-item label="Code" prop="code">
        <el-input v-model="form.code" :disabled="true" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { apiError, labelWidth } from '@/mixins'
import TranslatableInput from '@/components/Form/TranslatableInput'
import { initMultilingual } from '@/services/helpers'
import SavePageHeader from '@/components/ui/SavePageHeader'
export default {
  components: {
    TranslatableInput,
    SavePageHeader,
  },
  mixins: [apiError('getCountryError'), labelWidth],
  data: () => ({
    form: {
      names: initMultilingual(),
    },
  }),
  computed: {
    ...mapState('country', ['country', 'getCountryError']),
    isFetch() {
      return this.$route.params.id !== undefined
    },
  },
  async mounted() {
    if (this.isFetch) {
      await this.getCountry({
        routeParameters: {
          id: this.$route.params.id,
        },
      })
      this.form = {
        ...this.country.data,
        names: initMultilingual(this.country.data.names),
      }
    }
  },
  methods: {
    ...mapActions('country', ['getCountry']),
  },
}
</script>
